'use client';

import { useEffect } from 'react';

import { Button } from '@/components';

/**
 * @file error.jsx
 * @description UI if any runtime error occurred
 * @version 0.0.1
 * Created at: 11/08/2025
 * Updated at: 11/08/2025
 */
const Error = ({ error, reset }) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <section className="flex h-svh items-center justify-center">
      <div className="p-4">
        <h2 className="text-xl">Something went wrong!</h2>
        <Button className="mx-auto mt-4 block" onClick={() => reset()}>
          Try again
        </Button>
      </div>
    </section>
  );
};

export default Error;
